import axios from "axios";

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Accept'] = 'application/json';

const source = axios.CancelToken.source();
window.api = axios.create({
    baseURL: window.global.api_url,
    cancelToken: source.token,
    withCredentials: true,
});

window.http = axios.create({
    cancelToken: source.token,
    withCredentials: true,
});

// Intercept all delete requests and ask for confirmation
window.api.interceptors.request.use(async (config: any) => {
    if (config.method === 'delete' && config.data?.showDeleteWarning !== false) {
        const swalFire: any = {
            title: window.trans('attributes.are_you_sure'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#1185c7',
            cancelButtonColor: '#868686',
            confirmButtonText: window.trans('actions.yes'),
            cancelButtonText: window.trans('actions.cancel')
        };

        let defaultText = swalFire.html = window.trans('You cannot reverse this.');
        if (config.hasOwnProperty('delete') && config.hasOwnProperty('model')) {

            if (window.store.getters.hasOwnProperty('entities/' + config.model + '/find')) {
                const entity = window.store.getters['entities/' + config.model + '/find'](config.delete);

                if (entity !== null && config.hasOwnProperty('name_prop') && entity.hasOwnProperty(config.name_prop)) {
                    let deleteAttribute = config.hasOwnProperty('translate') && config.translate
                        ? entity[config.name_prop]
                        : entity[config.name_prop];

                    if (deleteAttribute === null || deleteAttribute === '') {
                        const singularModelName = window.pluralize.singular(config.model);
                        deleteAttribute = window.ucFirst(singularModelName);
                    }

                    defaultText = window.trans('attributes.deleting', {
                        attribute: deleteAttribute,
                    });
                }
            }
        }

        swalFire.html = defaultText;

        const result = await window.Swal.fire(swalFire);

        if (result.isConfirmed) {
            return config;
        } else {
            const e = new axios.Cancel('delete-confirm-failed');
            throw e.message;
        }
    } else {
        return config;
    }
});

// Intercept all responses. 2xx, 4xx responses will just return the same response. 5xx responses will show error popup
window.api.interceptors.response.use(response => response, error => {
    // Drop cancel request silently
    if (axios.isCancel(error)) {
        return new Promise(() => {
        });
    }

    if (error.response) {
        if (error.response.status >= 500) {
            window.Swal.fire(
                window.trans('Server Error'),
                error.response.data.message ?? window.trans('Unknown error occurred, please try again later'),
                'error'
            );

            return Promise.reject(error);
        } else if (error.response.status >= 400 && error.response.status <= 499 && ![422, 401, 403].includes(error.response.status)) {
            window.Swal.fire(
                window.trans('Oops!'),
                error.response.data.message ?? window.trans('Unknown error occurred, please try again later'),
                'error'
            );

            return Promise.reject(error);
        } else if (error.response.status === 403) {
            window.Swal.fire(
                '',
                error.response.data.message ?? window.trans('You currently don\'t have permission to perform this action. Contact a team admin to resolve this.'),
                'warning'
            );

            return Promise.reject(error);
        }
    } else if (error.request) {
        window.Swal.fire(
            window.trans('No Response'),
            error.message ?? window.trans('We were unable to get a response from this request. Please try again later'),
            'error'
        );
    } else if (error !== 'delete-confirm-failed') {
        window.Swal.fire(
            window.trans('Request Error'),
            error.message ?? window.trans('Something went wrong while setting up this request. Please try again later'),
            'error'
        );
    }

    return Promise.reject(error);
});
